﻿import "../css/styles.scss";
import { inViewPort, ViewportObserver } from './ViewportObserver';
import { observeElementSize } from './elementSizeObserver';
import { HoverObserver } from './HoverObserver';
import { BlazorReconnectObserver } from './BlazorReconnectObserver';
//import { setHash, getHash } from './setHash';
//import { initializeTabComponent, setTabComponentOverflow, setTabComponentOverflowByIdentifier } from './tabs';
//import { setTitle } from './setTitle';
//import { getCurrentUrl, getCurrentQueryString } from './urls';

import { saveAsFile } from './saveFile';
import { debounceEvent } from './events';
import { submitForm, focusElement } from './forms';

import './iframes';

declare global {
	interface Window {
		inViewPort: any;
		saveAsFile: any;
		//setTitle: any;
		//setHash: any;
		//getHash: any;
		afterRouteChange: any;
		debounceEvent: any;
		//initializeTabComponent: any;
		//setTabComponentOverflow: any;
		//setTabComponentOverflowByIdentifier: any;
		submitForm: any;
		//getCurrentUrl: any;
		//getCurrentQueryString: any;
		focusElement: any;
	}
}


window.addEventListener('load', (e) => {	

	observeElementSize();

	//* Setup up mutaion observer for new elements
	const config = { attributes: false, childList: true, subtree: true };
	const observer = new MutationObserver((mutations, observer) => {		
		ViewportObserver();
		HoverObserver();
	});
	observer.observe(document.getElementsByTagName("body")[0], config);

	ViewportObserver();
	HoverObserver();
	BlazorReconnectObserver();
});

window.inViewPort = inViewPort;

//window.setHash = setHash;
//window.getHash = getHash;
/*
window.initializeTabComponent = initializeTabComponent;
window.setTabComponentOverflow = setTabComponentOverflow;
window.setTabComponentOverflowByIdentifier = setTabComponentOverflowByIdentifier;
*/
//window.setTitle = setTitle;
/*
window.getCurrentUrl = getCurrentUrl;
window.getCurrentQueryString = getCurrentQueryString;
*/

window.saveAsFile = saveAsFile;
window.debounceEvent = debounceEvent;
window.submitForm = submitForm;
window.focusElement = focusElement;
